import React from "react";
import { Card as MuiCard, CardContent, Typography, Link } from "@mui/material";
import { Info } from "../types/types";

interface StyledCardProps {
    info: Info;
}

export const Card: React.FC<StyledCardProps> = ({ info: { title, description, link, date, name } }: StyledCardProps) => {
    return (
        <Link
            href={link}
            target="_blank"
            rel="noopener"
            underline="none"
            sx={{
                color: "primary.main",
                stextDecoration: "none",
            }}
        >
            <MuiCard
                sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    marginBottom: 2,
                    boxShadow: 1,
                    backgroundColor: "background.paper",
                    margin: "10px 0px",
                    padding: "3px",
                    ":hover": {
                        backgroundColor: "purple"
                    }
                }}
            >
                <CardContent sx={{ flex: 1 }}>
                    <Typography
                        variant="h6"
                        component="div"
                        gutterBottom
                        sx={{ color: "primary.main" }}
                    >
                        {title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        {date}
                    </Typography>
                    <Typography variant="body2" color="text.primary" >
                        {description}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ fontStyle: "italic" }}>
                        ~ From {name}
                    </Typography>
                </CardContent>
            </MuiCard>
        </Link>
    );
};